var DEFAULT_AMOUNTS = [300, 600, 1200];
var DEFAULT_EUR_AMOUNTS = [30, 60, 120];

export var getSupportedAmounts = function getSupportedAmounts(_ref) {
  var currency = _ref.currency,
      providerType = _ref.providerType,
      lastDepositAmount = _ref.lastDepositAmount,
      remainingDepositLimit = _ref.remainingDepositLimit,
      methodMax = _ref.methodMax,
      methodMin = _ref.methodMin,
      balance = _ref.balance,
      customAmount = _ref.customAmount,
      cancelWithdrawalAmount = _ref.cancelWithdrawalAmount,
      spainRemainingDepositAmount = _ref.spainRemainingDepositAmount;

  var amounts = !['eur', 'cad', 'nzd', 'chf', 'gbp'].includes(currency.toLowerCase()) ? DEFAULT_AMOUNTS : DEFAULT_EUR_AMOUNTS;

  if (lastDepositAmount && lastDepositAmount > 0) {
    amounts = [lastDepositAmount, lastDepositAmount * 2, lastDepositAmount * 3];
  }

  if (spainRemainingDepositAmount && spainRemainingDepositAmount > 0) {
    amounts = [spainRemainingDepositAmount * 0.5, spainRemainingDepositAmount * 0.75, spainRemainingDepositAmount];
  }

  if (remainingDepositLimit !== false && amounts[2] > remainingDepositLimit) {
    amounts = [remainingDepositLimit * 0.5, remainingDepositLimit * 0.75, remainingDepositLimit];
  }

  if (methodMax && amounts[2] > methodMax) {
    amounts = [methodMax * 0.5, methodMax * 0.75, methodMax];
  }

  if (balance && amounts[2] > balance) {
    amounts = [balance * 0.5, balance * 0.75, balance];
  }

  if (methodMin && amounts[0] < methodMin) {
    amounts = [methodMin, Number(methodMin) + Number((amounts[2] - methodMin) / 2), amounts[2]];
  }

  amounts = amounts.map(function (a) {
    return Math.floor(a);
  });
  if (amounts.some(function (a) {
    return a < methodMin;
  })) {
    amounts = [methodMin, methodMin, methodMin];
  }

  if (providerType === 'reverseWithdrawal') {
    amounts = [cancelWithdrawalAmount];
  }

  if (customAmount && customAmount.value) {
    amounts = customAmount.value[currency];
  }

  return amounts;
};

export var matchProviderType = function matchProviderType(first, second) {
  var fType = first.providerType;
  var sType = second.providerType;


  if (first.service) fType = fType + first.service;
  if (second.service) sType = sType + second.service;

  if (!fType || !sType) return;

  return sType.toLowerCase() === fType.toLowerCase();
};

export var getPaymentForm = function getPaymentForm(_ref2) {
  var txType = _ref2.txType,
      service = _ref2.service;

  if (txType === 'BankDeposit' && ['ASTROPAYBANK', 'WEBPAY', 'BOLETO'].includes(service)) return 'AstroPayBankDeposit';

  return txType;
};